import React from 'react';
import { BrowserRouter} from 'react-router-dom';
import { Route, Switch } from "react-router-dom";
import  './App.module.scss';

import * as ScrollMagic from "scrollmagic";
import {TimelineMax, TweenMax, gsap} from "gsap";
import { ScrollMagicPluginGsap } from "utils/ScrollMagicGsapPlugin";
import ScrollToPlugin from 'gsap/ScrollToPlugin';


import Home from "components/home/Home";

/** redux **/
import { Provider } from "react-redux";
import { createStore, combineReducers } from "redux";
import AssetsLoadedReducer from "./redux/AssetsLoadedReducer";
import AnimationReducer from "./redux/AnimationReducer";
import WrapSelectionReducer from "./redux/WrapSelectionReducer";
import WindowReducer from "./redux/WindowReducer";
import WindowWatcher from "components/windowWatcher/WindowWatcher";
import AccessibilityReducer from "./redux/AccessibilityReducer";
import PanelsReducer from "./redux/PanelsReducer";
import StemsDownload from "components/stemsDownload/StemsDownload";

/** initialize redux **/
const rootReducer = combineReducers({
    assetsLoaded: AssetsLoadedReducer,
    animationCount: AnimationReducer,
    panelData: PanelsReducer,
    wrapSelection: WrapSelectionReducer,
    window: WindowReducer,
    accessible: AccessibilityReducer
});
const combinedState = createStore(rootReducer);

/** initialize scroll and gsap **/
ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
gsap.registerPlugin(ScrollToPlugin);

const App = () => {

  const Routes = () => {

    return (
        <Switch>

            {/* PATH CATCH ROUTE  */}

            <Route exact path={'/conteststems'} component={StemsDownload} />
            <Route path={'/'} component={Home} />

        </Switch>
    )
  };

  return (
      <Provider store={combinedState}>
        <BrowserRouter>
            <Routes />
            <WindowWatcher/>
        </BrowserRouter>
      </Provider>
  )

}

export default App;
